// Generated by CoffeeScript 1.9.2
module.exports = function(max, idle) {
  var _batch, _queued, _running, next, result, start;
  _batch = {};
  _running = [];
  _queued = [];
  start = function(entry) {
    var cancel;
    _running.push(entry);
    entry.startedAt = new Date().getTime();
    cancel = entry.task(function(err, cb) {
      var fin, i, index, key, len, ref;
      index = _running.indexOf(entry);
      _running.splice(index, 1);
      if (err == null) {
        fin = new Date().getTime();
        ref = entry.keys;
        for (i = 0, len = ref.length; i < len; i++) {
          key = ref[i];
          _batch[key] = fin - entry.startedAt;
        }
        cb(entry.keys);
      }
      return next();
    });
    if (_running.indexOf(entry) === -1) {
      return;
    }
    if (typeof cancel !== 'function') {
      cancel = function() {};
    }
    entry.cancel = cancel;
    return next();
  };
  next = function() {
    var queuedCount, runningCount;
    if (idle != null) {
      runningCount = _running.filter(function(r) {
        return !r.isAsync;
      }).length;
      queuedCount = _queued.filter(function(r) {
        return !r.isAsync;
      }).length;
      if (runningCount === 0 && queuedCount === 0) {
        idle(_batch);
        _batch = {};
      }
    }
    if (_queued.length === 0) {
      return;
    }
    if (_running.length >= max) {
      return;
    }
    return start(_queued.shift());
  };
  return result = {
    cancel: function(keys) {
      _queued = _queued.filter(function(entry) {
        entry.keys = entry.keys.filter(function(key) {
          return keys.indexOf(key) === -1;
        });
        if (entry.keys.length !== 0) {
          return true;
        }
        return false;
      });
      return _running = _running.filter(function(entry) {
        entry.keys = entry.keys.filter(function(key) {
          return keys.indexOf(key) === -1;
        });
        if (entry.keys.length !== 0) {
          return true;
        }
        entry.cancel();
        return false;
      });
    },
    add: function(isAsync, keys, task) {
      var entry;
      entry = {
        keys: keys,
        task: task,
        isAsync: isAsync
      };
      result.cancel(keys);
      return _queued.push(entry);
    },
    exec: function() {
      return next();
    }
  };
};
